import { dateTime } from '@/_shared';

import type {
  DeliverableWholesalePriceFormSchema,
  DeliverableWholesalePriceQuerySchema,
  DeliverableWholesalePriceUpdateSchema,
} from './model';

export function wholesalePriceFormToUpdate(
  deliverable_wholesale_price: DeliverableWholesalePriceFormSchema[],
  id: number
): DeliverableWholesalePriceUpdateSchema[] {
  return deliverable_wholesale_price.map((item) => ({
    ...item,
    agreement_deliverable_id: id,
    start_date: item.start_date ? dateTime.format(item.start_date, 'YYYY-MM-DD') : null,
    end_date: item.end_date ? dateTime.format(item.end_date, 'YYYY-MM-DD') : null,
    wholesale_price: item?.wholesale_price ?? 0,
    wholesale_discount: item?.wholesale_discount ?? 0,
  }));
}

export function wholesalePriceQueryToForm(
  deliverable_wholesale_price: DeliverableWholesalePriceQuerySchema[]
): DeliverableWholesalePriceFormSchema[] {
  return (
    deliverable_wholesale_price?.map((item) => ({
      ...item,
      wholesale_discount: item?.wholesale_discount ?? 0,
      wholesale_price: item?.wholesale_price ?? 0,
    })) ?? []
  );
}
